module.exports = __webpack_public_path__ + "static/media/HotelTravelLandingPage.4fde2dfb.jpeg";